// ========================================================
// FANCYBOX 3.5
// @link https://obu.edu/_resources/ldp/galleries/fancybox/#options
// ========================================================

/**
 * Full screen popup.
 * Make sure to call inside a jQuery ready function to ensure the DOM is fully loaded.
 */
$(() => {
	$('a[href="#popupForm"]').fancybox({
		baseClass: 'fancybox-fullscreen-popup-form',
		touch: false,
		autoFocus: false,
	});
});


/**
 * Fancybox Custom Close Button
 */
const fancyBoxCloseBtnTemplate = `
<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small">
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<g opacity="0.6">
			<path d="M6 17.2269L17.3137 5.91322" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M12 11.9688H12.0001" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M6 5.9762L17.3137 17.2899" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
		</g>
	</svg>
</button>`;

$.fancybox.defaults.btnTpl.smallBtn = fancyBoxCloseBtnTemplate;
$.fancybox.defaults.btnTpl.close = fancyBoxCloseBtnTemplate;
